import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {PesquisaResolver} from './pesquisa/pesquisa-resolver.service';
import {DetalhamentoProdutoResolver} from './detalhamento-produto/detalhamento-produto-resolver.service';
import {HomeResolver} from './home/home-resolver.service';
import {DesenvolvedorResolver} from './desenvolvedor/desenvolvedor-resolver.service';
import {ProductAdminComponent} from './admin/product-admin/product-admin.component';
import {AdminComponent} from './admin/admin.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        loadChildren: './home/home-initial.module#HomeInitialModule',
        resolve: {
            res: HomeResolver
        }
    },
    {
        path: 'pesquisa',
        loadChildren: './pesquisa/pesquisa-principal.module#PesquisaPrincipalModule',
        resolve: {
            res: PesquisaResolver
        }
    },
    {
        path: 'pesquisa/:term',
        loadChildren: './pesquisa/pesquisa-principal.module#PesquisaPrincipalModule',
        resolve: {
            res: PesquisaResolver
        }
    },
    {
        path: 'produto/:id',
        loadChildren: './detalhamento-produto/detalhamento-produto.module#DetalhamentoProdutoModule',
        resolve: {data: DetalhamentoProdutoResolver},
        data: {path: 'produto/:id'}
    },
    {
        path: 'desenvolvedor/:id',
        loadChildren: './desenvolvedor/desenvolvedor-principal.module#DesenvolvedorPrincipalModule',
        resolve: {data: DesenvolvedorResolver},
        data: {path: 'desenvolvedor/:id'}
    },
    {
        path: 'admin',
        component: AdminComponent
    },
    {
        path: 'page-not-found',
        component: PageNotFoundComponent
    },
    {
        path: 'admin/:id/:type',
        data: {path: 'admin/:id:type'},
        component: ProductAdminComponent
    },
    {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: false, relativeLinkResolution: 'legacy'})],
    exports: [RouterModule],
    providers: [HomeResolver, PesquisaResolver, DetalhamentoProdutoResolver, DesenvolvedorResolver]
})
export class AppRoutingModule {
}
